import React from 'react';

const FAMILY_TINT = {
  SMARTBOT: 'text-emerald-600',
  POOLBOT: 'text-blue-600',
  SHINEBOT: 'text-cyan-600',
  LAWNBOT: 'text-green-600',
};

export const BrandChip = ({ family, className = 'top-4 right-4' }) => (
  <span
    className={`absolute ${className} z-10 inline-flex items-center gap-1.5 bg-white/90 backdrop-blur-sm border border-black/5 rounded-full px-2.5 py-1 shadow-sm pointer-events-none select-none`}
    data-testid="brand-chip"
  >
    <img src="/favicon.svg" alt="" aria-hidden="true" className="w-3.5 h-3.5" />
    <span className="font-heading text-[11px] font-bold tracking-tight text-gray-900 leading-none whitespace-nowrap">
      Harpalyk{family ? <span className={`font-semibold ${FAMILY_TINT[family] || 'text-gray-500'}`}> · {family}</span> : null}
    </span>
  </span>
);

export default BrandChip;
